import { PayMonthNumberOfReportedViewModel } from '@fora-monorepo/employer-my-pages-common/types';

export const mockPayMonthNumberOfReported: PayMonthNumberOfReportedViewModel = {
  numberOfActiveEmployments: 67,
  numberOfReportedPayrollsOnActiveEmployments: 45,
};
